import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import checkCardBalance from './api';

const name = 'checkCardBalance';

const balance = createAsyncThunk(
  'checkCardBalance/balance',
  async (payload) => {
    const fn = checkCardBalance.balance(payload);
    const response = await fn();
    // await dispatch(businesses.actions.fetchBusiness(response.businessId));

    return response;
  }
);

const mailTracking = createAsyncThunk(
  'checkCardBalance/mailTracking',
  async (payload) => {
    const fn = checkCardBalance.mailTracking(payload);
    const response = await fn();

    return response;
  }
);

const saveMailTracking = createAsyncThunk(
  'checkCardBalance/saveMailTracking',
  async (payload) => {
    const response = await checkCardBalance.saveMailTracking(payload);

    return response;
  }
);

const normalizeCardDetails = (payload = {}) => ({
  ...payload,
  giftFirstName:
    payload.giftFirstName ||
    payload.gifteeFirstName ||
    payload.firstName ||
    payload.gifterFirstName ||
    '',
  giftLastName:
    payload.giftLastName ||
    payload.gifteeLastName ||
    payload.lastName ||
    payload.gifterLastName ||
    '',
  giftAddress: payload.giftAddress || payload.address || '',
  giftCity: payload.giftCity || payload.city || '',
  giftState: payload.giftState || payload.state || '',
  giftZipcode: payload.giftZipcode || payload.zipcode || '',
  carrierName:
    payload.carrierName || payload.trackingCarrier || payload.carrier || '',
  carrierWebsiteAddress:
    payload.carrierWebsiteAddress ||
    payload.trackingWebsite ||
    payload.website ||
    '',
  trackingNumber: payload.trackingNumber || '',
});

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      error: false,
      details: '',
      cardDetails: {},
    },
    reducers: {
      setCardDetails: (state, { payload }) => {
        state.cardDetails = { ...state.cardDetails, ...payload };
      },
      resetCardDetails: (state) => {
        state.cardDetails = {};
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(balance.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(balance.fulfilled, (state, action) => {
          state.isLoading = false;
          state.details = action.payload?.orderNumber || '';
        })
        .addCase(balance.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(mailTracking.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(mailTracking.fulfilled, (state, action) => {
          state.isLoading = false;
          state.cardDetails = normalizeCardDetails(action.payload);
        })
        .addCase(mailTracking.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(saveMailTracking.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(saveMailTracking.fulfilled, (state, action) => {
          state.isLoading = false;
          state.cardDetails = {
            ...state.cardDetails,
            ...normalizeCardDetails(action.payload),
            carrierWebsiteAddress: action.meta.arg.website,
            carrierName: action.meta.arg.carrier,
            trackingNumber: action.meta.arg.trackingNumber,
          };
        })
        .addCase(saveMailTracking.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    },
  }),
};

const selectors = {
  selectIsLoading: (state) => getOr('', 'isLoading', state[name]),
  selectCardDetails: (state) => getOr({}, 'cardDetails', state[name]),
};

export default {
  actions: {
    ...actions,
    balance,
    mailTracking,
    saveMailTracking,
  },
  selectors,
  reducer,
  name,
};
